import script from "./MeetingRequestCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetingRequestCard.vue?vue&type=script&setup=true&lang=js"

import "./MeetingRequestCard.vue?vue&type=style&index=0&id=4497d5b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4497d5b5"]])

export default __exports__